var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3491 13.2786L15.0542 16.5474C14.9197 16.6808 14.8552 16.8365 14.8605 17.0144C14.8659 17.1923 14.9361 17.348 15.071 17.4814C15.2055 17.6037 15.3624 17.6677 15.5417 17.6735C15.721 17.6793 15.8779 17.6152 16.0124 17.4814L20.4504 13.0784C20.5177 13.0117 20.5654 12.9395 20.5937 12.8616C20.6219 12.7838 20.6356 12.7004 20.6347 12.6115C20.6347 12.5225 20.6206 12.4391 20.5923 12.3613C20.5641 12.2835 20.5168 12.2112 20.4504 12.1445L16.0124 7.74156C15.8891 7.61926 15.7349 7.55811 15.5498 7.55811C15.3646 7.55811 15.205 7.61926 15.071 7.74156C14.9365 7.87498 14.8693 8.03353 14.8693 8.21721C14.8693 8.40089 14.9365 8.55922 15.071 8.69219L18.3491 11.9444H4.11038C3.91986 11.9444 3.76005 12.0084 3.63094 12.1365C3.50183 12.2646 3.4375 12.4229 3.43795 12.6115C3.43795 12.8005 3.50251 12.959 3.63161 13.0871C3.76072 13.2152 3.92031 13.279 4.11038 13.2786H18.3491Z",
    fill: "#1D2739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrowNext.485ebf0cb35e23631e174e6bca4c794d.svg";
export { ForwardRef as ReactComponent };